import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import {Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography} from '@mui/material'
import {type ElementType, memo, type MouseEvent, type ReactNode} from 'react'
import type {PropsWithError} from '../../../../components/Skeleton/Skeleton'
import {TextSkeleton} from '../../../../components/Skeleton/TextSkeleton'

export interface NavItemProps extends PropsWithError {
  onSelect?: (event: MouseEvent) => void
  label?: ReactNode
  title?: ReactNode
  icon?: ReactNode
  disabled?: boolean
  expanded?: boolean
  level?: number
  item?: {
    to?: string
    component?: ElementType
  }
  secondaryAction?: ReactNode
}

export const NavItem = memo(({
  onSelect,
  secondaryAction,
  label,
  title,
  icon,
  item,
  level,
  expanded,
  disabled,
  error,
}: NavItemProps) => {
  let button = <ListItemButton onClick={onSelect} {...item} sx={{pl: 2 * (level ?? 1)}} disabled={disabled}>
    {icon && <ListItemIcon>{icon}</ListItemIcon>}
    <ListItemText primary={label ? <Typography noWrap>{label}</Typography> : <TextSkeleton error={error}/>}/>
    {expanded !== undefined && (expanded ? <ExpandLess/> : <ExpandMore/>)}
  </ListItemButton>

  if (title) {
    button = <Tooltip title={title}>
      <Box role="button" sx={{flexGrow: 1}}>{button}</Box>
    </Tooltip>
  }
  return <ListItem disablePadding secondaryAction={secondaryAction}>
    {button}
  </ListItem>
})
